import { t } from 'ember-intl';
import Heading from 'tio-ui/components/heading';
import Text from 'tio-ui/components/text';
import type { TOC } from '@ember/component/template-only';

interface QuestionsNumberedStepSignature {
  Args: {
    /** Translation key for the step number badge (e.g. "number_one") */
    number: string;
    /** Translation key for the step title */
    title: string;
    /** Translation keys for the bulleted points */
    points: string[];
    /** Optional translation key rendered as a paragraph above the list */
    intro?: string;
  };
  Element: HTMLDivElement;
}

/**
 * One numbered step of an application walkthrough: a round number badge, the
 * step title, and its bullets.
 *
 * The title is an h4 because a step always sits inside an info card, whose own
 * title is the h3 (`page-header.instructions.md` § The heading ladder).
 */
const QuestionsNumberedStep: TOC<QuestionsNumberedStepSignature> = <template>
  <div ...attributes>
    <Heading @level={{4}} @role="panel-title" class="tio-row-flush mb-2">
      <span
        class="shrink-0 w-7 h-7 tio-bg-brand tio-fg-inverse rounded-full tio-inline-row-center tio-text-sm-semibold mr-3"
      >
        {{t @number}}
      </span>
      {{! wrapper keeps translation markup in inline flow instead of splitting into flex items }}
      <span class="app-rich-text">{{t @title htmlSafe=true}}</span>
    </Heading>
    {{#if @intro}}
      <Text @tag="p" @variant="muted" class="ml-14 mb-2">
        {{t @intro}}
      </Text>
    {{/if}}
    <ul class="list-disc ml-14 space-y-2">
      {{#each @points as |point|}}
        <li>
          <Text @variant="muted" class="app-rich-text">
            {{t point htmlSafe=true}}
          </Text>
        </li>
      {{/each}}
    </ul>
  </div>
</template>;

export default QuestionsNumberedStep;
